<template>
<div>
    <Calendar v-model="value" :dateFormat="props.format" :showIcon="props.showIcon" :iconDisplay="props.iconDisplay" 
    :view="props.view" :touchUI="props.touchUI" :minDate="props.minDate" :maxDate="props.maxDate" :inputId="props.inputId" 
     :placeholder="props.placeholder" :showTime="props.showTime" :timeOnly="props.timeOnly" :inputClass="props.class" 
     @date-select="$emit('date-select')" />
    <small class="block text-red-600">{{ errorMessage || '&nbsp;' }}</small>  
</div>
</template>
<script setup>
import { watch } from "vue" 
import Calendar from "primevue/calendar" 
import { useField } from 'vee-validate';


const props = defineProps({
    name:  {
        type: String,
        required: true
    },
    showTime:  {
        type: Boolean,
        required: false
    },
    timeOnly:  {
        type: Boolean,
        required: false
    },
    iconDisplay:  {
        type: String,
        required: false
    },
    class: {
        type: String,
        required: false,
        default: ''
    },
    format: {
        type: String,
        required: false
    },
    showIcon: {
        type: Boolean,
        required: false
    },
    view: {
        type: String,
        required: false,
        default: 'date'
    },
    touchUI: {
        type: Boolean,
        required: false,
        default: false
    },
    minDate: {
        type: Date,
        required: false,
        default: null
    },
    maxDate: {
        type: Date,
        required: false,
        default: null
    },
    inputId: {
        type: Date,
        required: false,
        default: null
    },
     placeholder:  {
        type: String,
        required: false
    }
  });


let { value, errorMessage, resetField } = useField(() => props.name);

watch(() => value.value, (newValue) => {
     if(props.name == "exend_date" && newValue == null){
         resetField({
            errors: []
        }); 
    }
})

</script>
